import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {FileUploadComponent} from './container/file-upload.component';
import {SharedModule} from '@shared/shared.module';
import {MatIconModule} from '@angular/material/icon';
import {TranslateModule} from '@ngx-translate/core';
import {CommonModule} from "@angular/common";

const routes: Routes = [
    {
        path: 'upload',
        component: FileUploadComponent,
    }
];

@NgModule({
    declarations: [
        FileUploadComponent
    ],
    exports: [
        FileUploadComponent
    ],
    imports: [
        RouterModule.forChild(routes),
        SharedModule,
        MatIconModule,
        TranslateModule,
        CommonModule
    ]
})
export class FileUploadModule {
}
